var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFancy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "33mm",
    height: 68.923,
    viewBox: "0 0 33 18.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -278.764)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1912 0 0 -.1912 -58.487 379.804)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.04 458.456)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000036",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-19.674-4.831-19.674-21.129c0 0 3.075-4.921 6.766 0 0 0 5.843-7.757 11.071-2.187 0 0 7.072-4.887 11.686.341 0 0 3.076-4.612 8.303 1.23 0 0 2.459-6.151 6.766-.307V3.165"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.874 458.456)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000036",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s19.675-4.831 19.675-21.129c0 0-3.076-4.921-6.767 0 0 0-5.843-7.757-11.071-2.187 0 0-7.071-4.887-11.686.341 0 0-3.076-4.612-8.303 1.23 0 0-2.459-6.151-6.765-.307V3.165"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.36 488.27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001240",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-1.266-8.501-8.319-10.323H-47.04s-5.83 0-7.12 9.109v27.857s-.782 4.933 4.125 4.933h44.851S-.415 28.54 0 21.86zm3.807 40.169h-63.248c-6.921 0-5.818-6.956-5.818-6.956V-6.071c1.82-12.845 10.04-12.845 10.04-12.845H-.614C9.334-16.347 11.118-4.359 11.118-4.359v30.827c-.585 9.42-7.311 13.701-7.311 13.701"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317.006 510.13)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001240",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.415 6.68 5.184 9.716 5.184 9.716h44.851c4.908 0 4.125-4.933 4.125-4.933v-27.858c-1.29-9.108-7.119-9.108-7.119-9.108H8.319C1.265-30.361 0-21.86 0-21.86zm-11.118 4.608v-30.827S-9.334-38.208.614-40.776h54.605s8.22 0 10.039 12.844v39.285s1.105 6.956-5.816 6.956H-3.807s-6.726-4.282-7.311-13.701"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.568 498.897)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001240",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s14.972 11.841 26.07 0l-.064-6.897S9.81 5.566 0-9.847"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(409.975 465.003)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4bb36",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v10.456c-.308 21.527-8.918 22.581-8.918 22.581-2.634 1.605-7.617 1.551-9.602 1.459-1.983.092-6.966.146-9.6-1.459 0 0-8.61-1.054-8.919-22.581V0s-7.995-2.439-1.845-8.6c0 0 3.749-7.699 16.944-7.699H-15.098C-1.904-16.299 1.845-8.6 1.845-8.6 7.995-2.439 0 0 0 0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancy);
export default __webpack_public_path__ + "static/media/fancy.0cf6880efcc511165c219981b18bfaaa.svg";
export { ForwardRef as ReactComponent };